import { fetchWithOrganization } from "./organizationRequest";

function normalizeBaseUrl(url) {
    return String(url || "").trim().replace(/\/$/, "");
}

function getServiceBaseUrl() {
    return normalizeBaseUrl(process.env.REACT_APP_SERVICE_API_URL || "http://localhost:8085");
}

const SERVICE_BASE_URL = getServiceBaseUrl();

function buildUrl(baseUrl, path) {
    const normalizedBase = normalizeBaseUrl(baseUrl);
    const normalizedPath = String(path || "").trim().replace(/^\/+/, "");
    return `${normalizedBase}/${normalizedPath}`;
}

async function requestJson(baseUrl, path, options = {}) {
    const {
        method = "GET",
        body = null,
        headers = {},
        credentials = "include",
    } = options;

    const response = await fetchWithOrganization(buildUrl(baseUrl, path), {
        method,
        credentials,
        headers: {
            "Content-Type": "application/json",
            ...headers,
        },
        ...(body !== null && body !== undefined ? { body: JSON.stringify(body) } : {}),
    });

    let payload = {};
    try {
        payload = await response.json();
    } catch {
        payload = {};
    }

    if (!response.ok) {
        const errorMessage = payload?.error || payload?.message || `Request failed (${response.status})`;
        const error = new Error(errorMessage);
        error.status = response.status;
        error.payload = payload;
        throw error;
    }

    return payload;
}

export async function getProducts() {
    const payload = await requestJson(SERVICE_BASE_URL, "/service/products", { method: "GET" });
    const entries = Array.isArray(payload?.products) ? payload.products : [];

    return entries.flatMap((entry) => {
        if (Array.isArray(entry?.products)) {
            return entry.products;
        }
        return entry?.id ? [entry] : [];
    });
}

export async function getPaymentConfig() {
    return requestJson(SERVICE_BASE_URL, "/service/payments/config", { method: "GET" });
}

export async function getProductById(productId) {
    return requestJson(SERVICE_BASE_URL, `/service/products/${encodeURIComponent(productId)}`, { method: "GET" });
}

export async function getProductPricing(productId) {
    const product = await getProductById(productId);
    return product?.pricing ?? product ?? null;
}
